const firstPathElement = document.location.pathname.split('/')[1]
export const language = !firstPathElement || firstPathElement === 'editor' ? 'de' : firstPathElement